import React, { FC } from 'react'
import { Tooltip, TooltipProps } from '@mui/material'

const EvtTooltip: FC<TooltipProps> = ({ children, ...props }) => {
    return <Tooltip {...props}>{children}</Tooltip>
}

export default EvtTooltip
